import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable, combineLatest } from 'rxjs';

import { routerTransition } from '../../shared/components/animations/router.animations';
import { VSpecService } from '../../services/api/vspec.service';
import { DealerDetailService } from '../../services/api/dealer-detail.service';
import { isNil,get } from 'lodash';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import * as models from '../../shared/models';
import * as fromRootStore from '../../store';
import * as sharedDataActions from '../../store/actions/shared-data.action';
import { DDFeatureConfigService } from '../../shared/service/common/dd-feature-config.service';
import { FeatureConfigActionLoad, FeatureConfigActionSet } from '../../store/actions/feature-config.action';
import { LoaderService } from 'src/app/services/common/loader.service';
//
// Library Code
//
import * as Library from '../../../lib/core/library/index';
import { MenuActionSetToken } from '../../store/actions/menu.action';
import { OmnitureTags } from 'src/app/shared/omnitureTags';
import { TokenService } from 'src/app/services/api/token.service';
import hmacSHA1 from 'crypto-js/hmac-sha1';
import Base64 from 'crypto-js/enc-base64';

declare var google: any;

@Component({
  providers: [OmnitureTags],
  selector: 'dd-vehicles-page',
  templateUrl: './vehicles-page.component.html',
  styleUrls: ['./vehicles-page.component.scss']
})

export class VehiclesPageComponent implements OnInit, OnDestroy {

  public latLng: google.maps.LatLng;
  public zoomLevel: number;
  public mapSize: google.maps.Size;
  telemetryLocationImage: string;
  // Observable to save inventory screen data
  sharedDataStore$: Observable<models.SharedData>;
  // Subscriber for Shared Data Store
  sharedDataStoreSubscriber: any;
  // Field to store Shared Data from store
  sharedData: models.SharedData = <models.SharedData>{};

  panelOpenState = false;
  token: string;
  dealerCd: string;

  responseData: any;

  isMapLoaded = new BehaviorSubject<boolean>(false);
  isMapLoadedError = new BehaviorSubject<boolean>(false);

  constructor(
    private store: Store<fromRootStore.IAppState>,
    public route: ActivatedRoute,
    public router: Router,
    private loaderService: LoaderService,
    public vSpecService: VSpecService,
    public dealerDetailService: DealerDetailService,
    public _FeatureConfigService: DDFeatureConfigService,
    private environment: EnvironmentConfiguration,
    public omTag: OmnitureTags,
    private _tokenService: TokenService
  ) {
    this.sharedDataStore$ = store.select(fromRootStore.SharedDataStore);
    this.isMapLoaded = this._tokenService.isMapLoaded$;
    this.isMapLoadedError = this._tokenService.isMapLoadedError$;
  }

  ngOnInit() {
    this.loaderService.isLoading$.next(false);
    this.sharedDataStoreSubscriber = this.sharedDataStore$.subscribe(data => {
      // console.log('SHARED DATA REDUCER: ' + JSON.stringify(data));
      this.sharedData = Object.assign({}, data);
    });

    this.route.params.subscribe(params => {
      this.token = params['token'];
      // console.log('TOKEN: ' + this.token);
      // console.log('GOOGLE_MAP_API_KEY:' + environment.GOOGLE_MAP_API_KEY);
      this.sharedData.token = this.token;
      if (Library.isStringWithLength(this.token)) {
        this.store.dispatch(new MenuActionSetToken(this.token));
      }
      this.store.dispatch(new sharedDataActions.SetSharedDataAction(this.sharedData));
      this.vSpecService.getVehiclesByToken(this.token)
        .subscribe((res => {
          if (!isNil(res.result)) {
            this.responseData = res.result[0];
            if (!isNil(this.responseData) && !isNil(this.responseData.vehicles) && !isNil(this.responseData.vehicles[0])) {
              let financingArray = [];

              this.responseData.vehicles.forEach(element => {
                if (typeof element.ddFinancingTerms !== 'undefined' && !isNil(element.ddFinancingTerms)) {
                  let financingobject = {
                    "vin": element.vin,
                    "ddFinancingTerms": element.ddFinancingTerms
                  }
                  financingArray.push(financingobject)
                }

              });
              this.sharedData.tfsFinancingArray = financingArray;
            }
            this.store.dispatch(new sharedDataActions.SetSharedDataAction(this.sharedData));
            this.getDealerDetails(this.responseData.dealerCd);
            this._FeatureConfigService
              .get(this.dealerCd, null)
              .subscribe(resp => {
                if (resp.hasData()) {
                  this.store.dispatch(new FeatureConfigActionSet(resp.data));
                }
              });
          } else {
            this.router.navigate(['/not-found']);
          }
        }), e => {
          // console.log(e);
          this.router.navigate(['/not-found']);
        });
    }, e => {
      // console.log(e);
      this.router.navigate(['/not-found']);
    });

    combineLatest([this._tokenService.isMapLoaded$, this.sharedDataStore$])
      .subscribe(([isMapLoaded, sharedData]) => {
        if (isMapLoaded && sharedData.dealerDetails) {
          this.latLng = new google.maps.LatLng({
            lat: sharedData.dealerDetails.geographicalCoordinate.latitudeMeasure,
            lng: sharedData.dealerDetails.geographicalCoordinate.longitudeMeasure,
          });
          this.telemetryLocationImage = this.createStaticMapUrl(
            this.latLng,
            10,
            new google.maps.Size(480, 320)
          );
        }
      }, e => {
        // console.log(e);
      });
  }

  clickedMarker(label: string, index: number) {
    // console.log('clicked the marker: ${label || index}')
    document.getElementById('get-direction-link').click();
  }

  getDealerDetails(dealerCd: string) {
    if (!isNil(dealerCd)) {
      this.dealerDetailService.getDealerDetails(dealerCd, 'filterOnly', 'full', 'JSON', this.environment.DIS_API_KEY)
        .subscribe((res => {
          this.sharedData.dealerDetails = this.dealerDetailService
            .getFormattedDealerDetails(res);
          this.store.dispatch(new sharedDataActions.SetSharedDataAction(this.sharedData));
          this.omTag.fireOmnitureTag('vh_aa-pageload', {dealerCd: this.responseData.dealerCd}, this.sharedData);
        }));
    }
  }

  public createStaticMapUrl(
    location: google.maps.LatLng,
    zoomLevel: number = 16,
    size: google.maps.Size = this.mapSize,
    horizontalOffset: number = 0
  ): string {
    const apiKey = this._tokenService.apiKey;
    const secret = this._tokenService.secret;

    let mapUrl = '';

    if (location) {
      if (!(location instanceof google.maps.LatLng)) {
        const x: any = location;
        location = new google.maps.LatLng({'lat': x.lat, 'lng': x.lng});
      }
      const domain = 'https://maps.googleapis.com';

      const path = `/maps/api/staticmap?` +
        `center=${location.lat()},${location.lng() +
        horizontalOffset}` +
        `&markers=${location.lat()},${location.lng()}` +
        `&zoom=${zoomLevel}` +
        `&size=${size.width}x${size.height}` +
        `&key=${apiKey}`
      const signature = this.getSignature(path, secret);
      mapUrl = `${domain}${path}&signature=${signature}`;
    }

    return mapUrl;
  }

  private getSignature(path: string, secret: string): string{
    const secretBytes = Base64.parse(this.decodeWebSafe(secret));
    const signature = Base64.stringify(hmacSHA1(path, secretBytes));
    return this.makeWebSafe(signature);
  }

  private makeWebSafe(encodedString): string {
    return encodedString.replace(/\+/g, '-').replace(/\//g, '_');
  }

  private decodeWebSafe(encodedString: string) {
    return encodedString.replace(/\-/g, '+').replace(/\_/g, '/');
  }

  ngOnDestroy() {
    if (this.sharedDataStoreSubscriber) {
      this.sharedDataStoreSubscriber.unsubscribe();
    }
  }
}
